export default __webpack_public_path__ + "static/media/labTests.54ed3ec7.svg";